import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { ReactContext } from "@/app/providers/ReactContextProvider/react-context";
import { RefetchCommonType } from "@/common/api/types";
import { getProfileQueryOption } from "@/entities/profile/api/getProfileQueryOption";
import { ProfileProps } from "@/entities/profile/types";

type UseFetchProfile<T> = (refetchOnWindowFocus?: boolean) => {
  loadingProfile: boolean;
  isFetchedProfile: boolean;
  refetch: RefetchCommonType<T>;
  profile?: ProfileProps;
};

export const useFetchProfile: UseFetchProfile<ProfileProps | undefined> = (
  refetchOnWindowFocus = true,
) => {
  const token = localStorage.getItem("token") || "";
  const { setErrorMessage } = useContext(ReactContext);

  const { data, refetch, isLoading, isFetched } = useQuery(
    getProfileQueryOption({
      token,
      setErrorMessage,
      refetchOnWindowFocus,
    }),
  );

  return {
    loadingProfile: isLoading,
    isFetchedProfile: isFetched,
    refetch,
    profile: data,
  };
};
